const logoPath = "/brand-assets/comunihome-logo-v2.png";

const AppBootLoader = () => (
  <div
    className="flex min-h-screen min-h-[var(--app-dvh)] items-center justify-center px-4"
    role="status"
    aria-live="polite"
    aria-label="Cargando Comuni Home"
  >
    <div className="grid w-64 max-w-full place-items-center gap-4 px-6">
      <img className="h-20 w-20 object-contain" src={logoPath} alt="" />
      <div
        className="relative h-1.5 w-48 max-w-full overflow-hidden rounded-full bg-muted"
        role="progressbar"
        aria-label="Cargando Comuni Home"
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <span className="absolute inset-y-0 left-0 w-[45%] rounded-full bg-primary motion-safe:animate-[boot-loading_1.25s_ease-in-out_infinite] motion-reduce:w-full" />
      </div>
    </div>
  </div>
);

export default AppBootLoader;
